@if (vm(); as vm) {
  <article class="transit-info-card" [style.--transit-card-stripe]="vm.stripeColor">
    <header class="transit-info-card__header">
      <span class="transit-info-card__glyph" aria-hidden="true">{{ vm.glyph }}</span>
      <span class="transit-info-card__identity">
        <span class="transit-info-card__name">{{ vm.name }}</span>
        @if (vm.subtitle.length > 0) {
          <span class="transit-info-card__subtitle">{{ vm.subtitle }}</span>
        }
      </span>
      @if (vm.retrogradeLabel != null) {
        <span class="transit-info-card__rx">{{ vm.retrogradeLabel }}</span>
      }
    </header>

    <!-- Poort-rij: de focus van de kaart — grote nummers, mini center-icoon
         erboven, keynote1/keynote2 eronder. -->
    <div class="transit-info-card__row transit-info-card__row--gates">
      @if (vm.prevGate; as prevGate) {
        <div class="shift-cell shift-cell--prev">
          <span class="shift-cell__center-icon" [innerHTML]="prevGate.centerIcon" [attr.title]="prevGate.centerLabel"></span>
          <span class="shift-cell__value" [attr.title]="prevGate.tooltip">{{ prevGate.value }}</span>
          @for (keynote of prevGate.keynotes; track keynote) {
            <span class="shift-cell__keynote">{{ keynote }}</span>
          }
          <span class="shift-cell__stage">{{ vm.prevLabel }}</span>
        </div>
      }
      <span class="shift-cells__arrow" [attr.title]="vm.gateSinceTooltip">←</span>
      <div class="shift-cell shift-cell--current">
        <span class="shift-cell__center-icon" [innerHTML]="vm.currentGate.centerIcon" [attr.title]="vm.currentGate.centerLabel"></span>
        <span class="shift-cell__value" [attr.title]="vm.currentGate.tooltip">{{ vm.currentGate.value }}</span>
        @for (keynote of vm.currentGate.keynotes; track keynote) {
          <span class="shift-cell__keynote">{{ keynote }}</span>
        }
        <span class="shift-cell__stage">{{ vm.nowLabel }}</span>
      </div>
      @if (vm.nextGate; as nextGate) {
        <span class="shift-cells__arrow" [attr.title]="vm.gateShiftAtTooltip">→</span>
        <div class="shift-cell shift-cell--next">
          <span class="shift-cell__center-icon" [innerHTML]="nextGate.centerIcon" [attr.title]="nextGate.centerLabel"></span>
          <span class="shift-cell__value" [attr.title]="nextGate.tooltip">{{ nextGate.value }}</span>
          @for (keynote of nextGate.keynotes; track keynote) {
            <span class="shift-cell__keynote">{{ keynote }}</span>
          }
          <span class="shift-cell__stage">{{ vm.nextLabel }}</span>
        </div>
      }
    </div>

    <!-- Lijn-rij: iets bescheidener dan de poort-rij, lijn-keynote eronder. -->
    @if (vm.currentLine != null) {
      <div class="transit-info-card__row transit-info-card__row--lines">
        @if (vm.prevLine; as prevLine) {
          <div class="shift-cell shift-cell--prev">
            <span class="shift-cell__value" [attr.title]="prevLine.tooltip">{{ prevLine.value }}</span>
            @for (keynote of prevLine.keynotes; track keynote) {
              <span class="shift-cell__keynote">{{ keynote }}</span>
            }
            <span class="shift-cell__stage">{{ vm.prevLabel }}</span>
          </div>
        }
        <span class="shift-cells__arrow" [attr.title]="vm.lineSinceTooltip">←</span>
        <div class="shift-cell shift-cell--current">
          <span class="shift-cell__value" [attr.title]="vm.currentLine.tooltip">{{ vm.currentLine.value }}</span>
          @for (keynote of vm.currentLine.keynotes; track keynote) {
            <span class="shift-cell__keynote">{{ keynote }}</span>
          }
          <span class="shift-cell__stage">{{ vm.nowLabel }}</span>
        </div>
        @if (vm.nextLine; as nextLine) {
          <span class="shift-cells__arrow" [attr.title]="vm.lineShiftAtTooltip">→</span>
          <div class="shift-cell shift-cell--next">
            <span class="shift-cell__value" [attr.title]="nextLine.tooltip">{{ nextLine.value }}</span>
            @for (keynote of nextLine.keynotes; track keynote) {
              <span class="shift-cell__keynote">{{ keynote }}</span>
            }
            <span class="shift-cell__stage">{{ vm.nextLabel }}</span>
          </div>
        }
      </div>
    }

    <!-- Tijdsectie: per rij (poort eerst, dan lijn — zelfde volgorde als de
         nummers) countdown + progressbar met de tijdsspanne eronder. -->
    <section class="transit-info-card__time">
      @for (stationLabel of vm.stationLabels; track stationLabel) {
        <p class="transit-info-card__station">{{ stationLabel }}</p>
      }
      @for (row of [vm.gateTime, vm.lineTime]; track row?.kindLabel) {
        @if (row != null) {
          <div class="transit-info-card__time-row">
            <span class="transit-info-card__time-text">{{ row.text }}</span>
            <span class="transit-info-card__time-kind">{{ row.kindLabel }}</span>
          </div>
          <div class="transit-info-card__progress" role="presentation">
            <span class="transit-info-card__progress-fill" [style.width.%]="row.progressPct"></span>
          </div>
          <p class="transit-info-card__range">
            <span class="transit-info-card__date">{{ row.range.fromDate }}</span>
            <span class="transit-info-card__time-part">{{ row.range.fromTime }}</span>
            <span class="transit-info-card__range-connector">{{ row.range.connector }}</span>
            <span class="transit-info-card__date">{{ row.range.toDate }}</span>
            <span class="transit-info-card__time-part">{{ row.range.toTime }}</span>
          </p>
        }
      }
    </section>
  </article>
}
